import { useLanguage } from "./LanguageContext";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { CiMenuFries } from 'react-icons/ci';

const Navbar = () => {
    const { language } = useLanguage(); // Get the current language
    const [open, setOpen] = useState(false);
    const openNavbar = () => setOpen(!open);

    return (
        <>
        {language === "en" ? (<nav className='bg-cream border-b border-lightBrown avenir'>
        <div className="h-10vh flex justify-between z-50 text-black lg:py-5 px-16 py-4 ">
            <div className='flex items-center flex-1'>
            <span className="text-3xl font-bold text-black didot">
                <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>DATSON</a>
            </span>
            </div>
            <div className='lg:flex  lg: flex-1 items-center justify-end font-normal hidden'>
            <div className='flex-5'>
                <ul className='flex gap-5 mr-16 text-[18]'>
                <Link to="/studio">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Studio</li>
                </Link>
                <Link to="/artist">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Artist</li>
                </Link>
                <Link to="/apply">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Apply</li>
                </Link>
                <Link to="/aftercare">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Aftercare</li>
                </Link>
                <Link to="/booking">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Booking</li>
                </Link>
                <Link to="/contact">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Contact</li>
                </Link>
                </ul>
            </div>
            </div>
            <div>
            <div className={`lg:hidden block absolute top-16 w-full left-0 right-0 z-50 transition-all bg-cream duration-500 ease-in-out ${open ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                <ul className='text-center text-xl p-20'>
                <Link to="/studio" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Studio</li>
                </Link>
                <Link to="/artist" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Artist</li>
                </Link>
                <Link to="/apply" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Apply</li>
                </Link>
                <Link to="/aftercare" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Aftercare</li>
                </Link>
                <Link to="/booking" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Booking</li>
                </Link>
                <Link to="/contact" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Contact</li>
                </Link>
                </ul>
            </div>
            </div>
            <button className='relative block lg:hidden w-8 h-8' onClick={openNavbar}>
            <FaTimes className={`text-3xl absolute inset-0 transition-opacity duration-500 ${open ? 'opacity-100' : 'opacity-0'}`} />
            <CiMenuFries className={`text-3xl absolute inset-0 transition-opacity duration-500 ${open ? 'opacity-0' : 'opacity-100'}`} />
            </button>
        </div>
        </nav>) : (<nav className='bg-cream border-b border-lightBrown avenir'>
        <div className="h-10vh flex justify-between z-50 text-black lg:py-5 px-16 py-4 ">
            <div className='flex items-center flex-1'>
            <span className="text-3xl font-bold text-black didot">
                <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>DATSON</a>
            </span>
            </div>
            <div className='lg:flex  flex-1 items-center justify-end font-normal hidden'>
            <div className='flex-5'>
                <ul className='flex gap-5 mr-16 text-[18] whitespace-nowrap'>
                <Link to="/studio">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Studio</li>
                </Link>
                <Link to="/artist">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Artist</li>
                </Link>
                <Link to="/apply">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Đăng ký</li>
                </Link>
                <Link to="/aftercare">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Chăm sóc</li>
                </Link>
                <Link to="/booking">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Đặt hẹn</li>
                </Link>
                <Link to="/contact">
                    <li className='hover:text-black transition hover:border-black hover:border-b-2 cursor-pointer duration-400'>Liên hệ</li>
                </Link>
                </ul>
            </div>
            </div>
            <div>
            <div className={`lg:hidden block absolute top-16 w-full left-0 right-0 z-50 transition-all bg-cream duration-500 ease-in-out ${open ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                <ul className='text-center text-xl p-20'>
                <Link to="/studio" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Studio</li>
                </Link>
                <Link to="/artist" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Artist</li>
                </Link>
                <Link to="/apply" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Đăng ký</li>
                </Link>
                <Link to="/aftercare" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Chăm sóc</li>
                </Link>
                <Link to="/booking" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Đặt hẹn</li>
                </Link>
                <Link to="/contact" onClick={openNavbar}>
                    <li className='my-4 py-4 border-b border-slate-800 '>Liên hệ</li>
                </Link>
                </ul>
            </div>
            </div>
            <button className='relative block lg:hidden w-8 h-8' onClick={openNavbar}>
            <FaTimes className={`text-3xl absolute inset-0 transition-opacity duration-500 ${open ? 'opacity-100' : 'opacity-0'}`} />
            <CiMenuFries className={`text-3xl absolute inset-0 transition-opacity duration-500 ${open ? 'opacity-0' : 'opacity-100'}`} />
            </button>
        </div>
        </nav>)}
        </>
    );
    };

    export default Navbar;
